// extracted by mini-css-extract-plugin
export default {"customCard":"reportDownload_customCard__k1kqT","customCardBody":"reportDownload_customCardBody__VBHZ-","userReportHeading":"reportDownload_userReportHeading__BFhnR"};